import { JSX } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore posthog is in the parent dir
import { usePostHog } from 'posthog-js/react';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { Maybe } from 'types/UtilityTypes';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';
import { ReferenceCandidate } from 'types/suggestions/LoadBuildingSuggestions';

import { ReferenceCandidateRow } from './ReferenceCandidateRow';
import { ReferenceCandidateAdapter } from './types';
import { findReferenceType, getUnusedReferenceCandidates } from './utils';

type ReferenceCandidatesProps = {
  candidates: ReferenceCandidate[];
  adapter: ReferenceCandidateAdapter;
};

// One group, under the reference cards, of the numbers Builder found in the email but did not
// file. A number with a type the TMS knows is listed under that type and Add files it there; an
// untyped number's Add opens a reference card holding it, for the rep to pick the type. A number
// the rep uses anywhere in the form leaves the group. Nothing is added until the rep clicks.
export function ReferenceCandidates({
  candidates,
  adapter,
}: ReferenceCandidatesProps): Maybe<JSX.Element> {
  const posthog = usePostHog();

  const unusedCandidates = getUnusedReferenceCandidates(
    candidates,
    adapter.usedNumbers
  );
  if (unusedCandidates.length === 0) {
    return null;
  }

  return (
    <div
      className='w-full rounded border border-neutral-200 p-3'
      data-testid='reference-candidates'
    >
      <Typography variant='body-sm' weight='semibold'>
        Other numbers from the email
      </Typography>
      <Flex direction='col' className='mt-1 w-full divide-y divide-neutral-100'>
        {unusedCandidates.map((candidate) => {
          const referenceType = findReferenceType(
            candidate.suggestedQualifier,
            adapter.referenceTypes
          );
          return (
            <ReferenceCandidateRow
              key={candidate.number}
              candidate={candidate}
              referenceType={referenceType}
              onAdd={() => {
                if (referenceType) {
                  adapter.addReference(candidate.number, referenceType.value);
                } else {
                  adapter.startReference(candidate.number);
                }
                posthog?.capture(
                  ButtonNamePosthog.LoadBuildingAddReferenceCandidate,
                  { hasSuggestedType: Boolean(referenceType) }
                );
              }}
            />
          );
        })}
      </Flex>
    </div>
  );
}
